import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Swal from "sweetalert2";

// Toast notifications
window.showToast = function(message, type = "success") {
  toastr.options = {
    closeButton: true,
    progressBar: true,
    positionClass: "toast-top-center",
    timeOut: 10000
  };
    // Ensure type is valid
    if (typeof toastr[type] === "function") {
      toastr[type](message);
    } else {
      toastr.info(message); // fallback
    }
};

// SweetAlert confirmation with CSRF + reload
window.confirmAction = function(title, text, url, method = "DELETE") {
  const token = document.querySelector("meta[name=csrf-token]").content;

  Swal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, proceed"
  }).then((result) => {
    if (result.isConfirmed) {
      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",   // ✅ important
          "X-CSRF-Token": token
        }
      })
      .then(response => {
        if (response.ok) {
          showToast("Action completed successfully", "success");
          setTimeout(() => {
            window.location.reload();   // ✅ reload page after success
          }, 1000);
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      })
      .catch(() => Swal.fire("Error!", "Network issue.", "error"));
    }
  });
};
